var helpers = {
	windowHeight: $(window).height(),
	init: function () {
		$(window).on(
			'resize',
			theme.helpers.throttle(function () {
				theme.helpers.windowHeight = $(window).height();
				$(window).trigger('scroll');
			}, 250)
		);
	},
	throttle: function (fn, wait) {
		var time = Date.now();
		return function () {
			if (time + wait - Date.now() < 0) {
				fn();
				time = Date.now();
			}
		};
	},
};

export { helpers };
